module.exports = __webpack_public_path__ + "static/img/cw-3.788d270.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/cw-3.jpg
 ** module id = 577
 ** module chunks = 2
 **/